import {useCallback} from 'react';
import type {UseSetApprovedValue} from 'schema/form/types';
import type {ChangeRequestAction, DataValue} from 'schemaDefinition/types';
import {useAppDispatch} from 'store/hooks';
import {metadataEditApproveChangeRequestItem} from '../metadataEditSlice';
import {useMetadataSchemasCodelists} from './useMetadataSchemasCodelists';

export const useChangeRequestSetApprovedValue: UseSetApprovedValue = (
  id: string,
) => {
  const dispatch = useAppDispatch();
  const codelists = useMetadataSchemasCodelists();

  return useCallback(
    (
      rootValuePath: string,
      itemAction: ChangeRequestAction,
      newValue?: DataValue,
      statusPath?: string,
    ) => {
      dispatch(
        metadataEditApproveChangeRequestItem({
          changeRequestId: id,
          rootValuePath: rootValuePath,
          itemAction: itemAction,
          newValue: newValue,
          statusPath: statusPath,
          codelists,
        }),
      );
    },
    [codelists, dispatch, id],
  );
};
